<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="d-flex flex-column ga-2 pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                    </div>
                    <div>Cette interface vous permet de gérer la liste d'attente de la bourse aux dossards de {{
                        mainStore.module.nom }}.</div>
                    <ListeAttenteBourseSearchForm @refresh="refreshOverview"></ListeAttenteBourseSearchForm>

                    <ListeAttenteBourseOverview ref="overview"></ListeAttenteBourseOverview>



                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ListeAttenteBourseSearchForm from "@/components/Administration/ListeAttenteBourse/SearchForm.vue";
import ListeAttenteBourseOverview from "@/components/Administration/ListeAttenteBourse/Overview.vue";
export default {
    name: 'ListeAttenteBourseAdmin',
    components: { ListeAttenteBourseSearchForm, ListeAttenteBourseOverview },
    computed: {
        ...mapStores(useMainStore),
    },
    methods: {
        refreshOverview() {
            if (this.$refs.overview && this.$refs.overview.fetchOverview) {
                this.$refs.overview.fetchOverview();
            }
        }
    }
}
</script>

<style lang="scss" scoped></style>